import { request } from "graphql-request";
import { graphql } from "gql/gql";

import { BACKEND_DOMAIN } from "utils/constants";
import {
  buildRequestHeaders,
} from "utils/helpers";

const queryFn = (
  accessToken: string,
  data: {
    reportFiltersetUid: string | null;
  }
) =>
  request({
    url: `${BACKEND_DOMAIN}/graphql`,
    document: query,
    variables: {
      reportFiltersetUid: data.reportFiltersetUid,
    },
    requestHeaders: buildRequestHeaders(accessToken),
  }).then((resp) => {

    if (!resp.prefilteredReports?.prefilteredBaselineReport.buildingCount === undefined)
      throw new Error(
        "Filterset building count returned null."
      );
    return (
      { count: resp.prefilteredReports?.prefilteredBaselineReport.buildingCount }
    );
  });

const query = graphql(`
  query buildingCount($reportFiltersetUid: Uuid) {
    prefilteredReports(reportFiltersetUid: $reportFiltersetUid) {
      prefilteredBaselineReport {
        buildingCount
      }
    }
  }
`);

export default queryFn;
